import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TableMui from 'src/components/TableMui'
import { selectItems } from 'src/features/tax-coupon/TaxCouponSelectors'
import { formatNumberBR } from 'src/utils'
import * as S from './TaxCouponTable.styles'
import { actions } from 'src/features/tax-coupon/TaxCouponState'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'

const format = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }

export default () => {
  const [deleteBatchFiscalCouponModalOpen, setDeleteBatchFiscalCouponModalOpen] = useState(false)
  const dispatch = useDispatch()
  const items = useSelector(selectItems)
  const [idBatchToDelete, setIdBatchToDelete] = useState<number>()

  const openDeleteModal = (idBatch: number) => {
    setIdBatchToDelete(idBatch)
    setDeleteBatchFiscalCouponModalOpen(true)
  }

  const onConfirmDeleteBatchFiscalCoupon = () => {
    if (idBatchToDelete) {
      dispatch(actions.deleteTaxCouponBatch(idBatchToDelete))
      setDeleteBatchFiscalCouponModalOpen(false)
    }
  }

  const formatItems = useCallback(() => items.map((item) => {
    let totalQuantity: number | string = 0
    let fieldQuantity: number | string = 0

    if (Number(item.boxQuantity)) {
      fieldQuantity = item.boxQuantity * Number(item.quantity)
      totalQuantity = fieldQuantity + (Number(item.single) || 0)
    } else {
      totalQuantity = formatNumberBR(Number(item.quantity) / 1000, 3)
      fieldQuantity = totalQuantity
    }

    let totalQuantityToCost = 0
    if (typeof totalQuantity === 'string') {
      totalQuantityToCost = Number(totalQuantity.replace('.', '').replace(',', '.'))
    } else {
      totalQuantityToCost = totalQuantity
    }

    const unitCostFormat = Number(item.unitCost) / 100
    const totalCost = (unitCostFormat * totalQuantityToCost).toLocaleString('pt-BR', format)
    const unitCost = unitCostFormat.toLocaleString('pt-BR', format)

    const deleteBatch = (
      <S.TrashButton
        handleClick={() => openDeleteModal(item.idBatch)}
      />
    )

    return ({
      ...item, totalQuantity, totalCost, fieldQuantity, unitCost, deleteBatch,
    })
  }), [items])

  return (
    <>
      <TableMui
        id='tax-coupon-items'
        columns={[
          { id: 'barcode', label: 'Código de barras' },
          { id: 'description', label: 'Descrição', width: '25em' },
          { id: 'fieldQuantity', label: 'Quantidade' },
          { id: 'single', label: 'Avulso' },
          { id: 'unitCost', label: 'Custo unitário' },
          { id: 'totalQuantity', label: 'Total qtd.' },
          { id: 'totalCost', label: 'Total valor' },
          { id: 'deleteBatch', label: 'Deletar' },
        ]}
        rows={formatItems()}
        emptyLabel='Nenhum produto encontrado/selecionado'
      />
      <ConfirmOrRejectModal
        show={deleteBatchFiscalCouponModalOpen}
        title='Excluir lote do cupom fiscal'
        description='Você tem certeza que deseja excluir o lote do cupom fiscal?'
        onConfirm={() => onConfirmDeleteBatchFiscalCoupon()}
        onReject={() => setDeleteBatchFiscalCouponModalOpen(false)}
        onClose={() => setDeleteBatchFiscalCouponModalOpen(false)}
        dataTestId='modal-reset-delete-batch'
      />
    </>
  )
}
